import { actionTypes } from '../actionTypes';
import { IProductionReportsState } from '../../model/productionReports';
import {
  filterOpenModsReportData
} from './openModsReportFilter'

export const openModsReportReducer = (state: IProductionReportsState[] = [], action: any) => {
  switch (action.type) {
    case actionTypes.LOAD_OPEN_MODE_REPORT_SUCCESS:
      return {
        AllReports: {
          'openModeData': filterOpenModsReportData(action.payload.OpenModsReport.records, 'OpenMode'),
          'modQuotesData': filterOpenModsReportData(action.payload.OpenModsReport.quotes, 'ModeQuote')
        }
      }
  }
  return state;
};

// lodash get 
// if (action.payload) {
//   const filterItemsArchivedItems =  _.filter(action.payload.gingerReports, ['archived', true])
//   return {
//     AllUsers: _.map(action.payload.gingerReports, _.partialRight(_.pick, ['prop_num', 'property_name', 'user_name','pin','last_updated','online_expires','update_type','sub_account'])),
//     Archived: _.map(filterItemsArchivedItems, _.partialRight(_.pick, ['prop_num', 'property_name', 'user_name','pin','last_updated','online_expires','update_type','sub_account'])),
//     ExpUsers30: _.map(action.payload.gingerReports, _.partialRight(_.pick, ['prop_num', 'property_name', 'user_name','pin','last_updated','online_expires']))
//   };
// }


// WEBPACK FOOTER //
// ./src/store/openModsReport/reducer.ts